import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  productGroupsLoadSuccess,
  productGroupsLoadFailure,
  PRODUCT_GROUPS_LOAD,
  ProductGroupsLoadAction
} from './actions'

function* productGroupsLoadSaga(action: ProductGroupsLoadAction) {
  const { accountId, projectId } = action

  try {
    let productGroups: any[] = []
    const response: { data: any[] } = yield call(() =>
      axios.get(
        `/accounts/${accountId}/projects/${projectId}/modules/delivery/admin/records/productgroups`,
        {}
      )
    )

    productGroups = response && response.data ? [...response.data] : []

    yield put(productGroupsLoadSuccess(accountId, projectId, productGroups))
  } catch (error) {
    console.error(error)
    yield put(productGroupsLoadFailure(accountId, projectId, error))
  }
}

export function* watch() {
  yield all([takeLatest(PRODUCT_GROUPS_LOAD, productGroupsLoadSaga)])
}
